"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findMainAddress;
var _sortAddresses = _interopRequireDefault(require("./sortAddresses"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Finds the main address from a list of addresses.
 *
 * The main address is the primary address, or, the
 * most recently created address (fallback).
 *
 * @param {any[]} addresses
 * @returns {any | null} The address found or null if not found.
 */
function findMainAddress() {
  var addresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortedAddresses = (0, _sortAddresses["default"])(addresses);
  return (sortedAddresses === null || sortedAddresses === void 0 ? void 0 : sortedAddresses[0]) || null;
}